import axios from "axios";

export async function fetchTargetGroupsLvl2(parentGroupId, schoolId) {
    try {
        const params = schoolId ? { schoolId } : undefined;
        const response = await axios.get(`/targetGroups/level2/${parentGroupId}`, { params });
        return response.data.targetGroups;
    } catch (e) {
        const text = e.response?.data?.message || "Ошибка загрузки целевых групп";
        throw new Error(text);
    }
}
